import React, { useEffect, useRef } from "react";
import Reveal from "./Reveal";

export default function Booking() {
  const initialized = useRef(false);

  useEffect(() => {
    if (initialized.current) return;
    initialized.current = true;

    // Inject Cal.com embed script (vendor snippet pattern)
    (function (C, A, L) {
      let p = function (a, ar) {
        a.q.push(ar);
      };
      let d = C.document;
      C.Cal =
        C.Cal ||
        function () {
          let cal = C.Cal;
          let ar = arguments;
          if (!cal.loaded) {
            cal.ns = {};
            cal.q = cal.q || [];
            d.head.appendChild(d.createElement("script")).src = A;
            cal.loaded = true;
          }
          if (ar[0] === L) {
            const api = function () {
              p(api, arguments);
            };
            const namespace = ar[1];
            api.q = api.q || [];
            if (typeof namespace === "string") {
              cal.ns[namespace] = cal.ns[namespace] || api;
              p(cal.ns[namespace], ar);
              p(cal, ["initNamespace", namespace]);
            } else p(cal, ar);
            return;
          }
          p(cal, ar);
        };
    })(window, "https://app.cal.com/embed/embed.js", "init");

    window.Cal("init", "30min", { origin: "https://app.cal.com" });

    window.Cal.ns["30min"]("inline", {
      elementOrSelector: "#my-cal-inline-30min",
      config: { layout: "month_view", useSlotsViewOnSmallScreen: "true" },
      calLink: "mb-shelar-a8hrax/30min",
    });

    window.Cal.ns["30min"]("ui", {
      cssVarsPerTheme: {
        light: { "cal-brand": "#ff3301" },
        dark: { "cal-brand": "#e4e4e4" },
      },
      hideEventTypeDetails: false,
      layout: "month_view",
    });
  }, []);

  return (
    <section className="section" id="booking">
      <div className="container-x">
        <Reveal>
          <div className="text-center mb-10">
            <div
              className="font-script"
              style={{ fontSize: 22, color: "var(--agero-orange)" }}
            >
              (Booking)
            </div>
            <h2
              className="font-display mt-3"
              style={{
                fontSize: "clamp(48px, 7vw, 110px)",
                letterSpacing: "-0.05em",
                lineHeight: 0.95,
              }}
            >
              Let&apos;s Talk
            </h2>
            <p
              className="mt-6 text-neutral-600 text-[17px] leading-relaxed mx-auto"
              style={{ maxWidth: 700 }}
            >
              Book a free 30-minute discovery call. No pitch. We figure out if
              there&apos;s a real fit. If not, we&apos;ll say so and
              point you somewhere better.
            </p>
          </div>
        </Reveal>

        {/* Cal.com embed container */}
        <Reveal delay={140} y={36}>
          <div className="cal-embed-wrap shadow-xl border border-neutral-200/60">
            <div
              id="my-cal-inline-30min"
              style={{ width: "100%", height: "100%", overflow: "scroll" }}
            />
          </div>
        </Reveal>

        <p className="mt-6 text-center text-neutral-500 text-sm">
          3 to 5 engagements at a time. Availability is limited.
        </p>
      </div>
    </section>
  );
}
